import { Zap, ShieldCheck, HomeIcon, XCircle, Clock, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import SEO from "@/components/site/SEO";

const pillars = [
  { icon: Zap, t: "Fast", c: "Quick decisions built for agents who move fast." },
  { icon: ShieldCheck, t: "Transparent", c: "Clear terms. No confusing legal jargon." },
  { icon: HomeIcon, t: "Real Estate Focused", c: "Built exclusively for licensed real estate professionals." },
  { icon: XCircle, t: "No Credit Check", c: "Approval is based on your pending commission." },
  { icon: Clock, t: "Same-Day Possibility", c: "Funds may arrive the same business day when verified." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <SEO
        title="About"
        description="Meet Hannah Howard Funding — built for agents who refuse to wait. Faster, clearer, and more agent-friendly commission advances."
        path="/about"
      />
      <section className="gradient-champagne py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <span className="overline">About Hannah Howard Funding</span>
          <h1 className="font-serif-lux text-5xl sm:text-6xl mt-5">Built for Agents Who <em className="italic text-[#5A3B31]">Refuse to Wait</em></h1>
          <p className="mt-8 text-[#5A3B31] text-lg leading-relaxed">
            Hannah Howard Funding helps real estate professionals access pending commissions before closing. Our mission is simple: make funding faster, clearer, and more agent-friendly, so hardworking agents can keep momentum in their business without waiting on settlement timelines.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {pillars.map(({ icon: I, t, c }) => (
            <div key={t} className="lux-card p-8">
              <span className="w-12 h-12 rounded-2xl bg-[#F3D8DA] text-[#2A1C14] flex items-center justify-center mb-5">
                <I size={22} strokeWidth={1.5} />
              </span>
              <h3 className="font-serif-lux text-2xl">{t}</h3>
              <p className="text-sm text-[#5A3B31] mt-2 leading-relaxed">{c}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="gradient-blush py-20 text-center">
        <h2 className="font-serif-lux text-4xl">Ready to keep moving?</h2>
        <Link to="/apply" className="btn-primary mt-8 inline-flex" data-testid="about-cta">
          Apply Now <ArrowRight size={18} strokeWidth={1.5} />
        </Link>
      </section>
    </div>
  );
}
